import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=99dd95a8&scoped=true"
import script from "./send-message.vue?vue&type=script&lang=ts"
export * from "./send-message.vue?vue&type=script&lang=ts"
import style0 from "./send-message.vue?vue&type=style&index=0&id=99dd95a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dd95a8",
  null
  
)

export default component.exports